import axios from "axios";
import { useEffect, useState } from "react";

interface SiteSetting {
  title: string;
  logo: string;
  partner_caption?: string;
  partner_logo?: string;
  sport_banner?: string;
  terms_conditions?: string;
}

const SiteSettings = () => {
  const [title, setTitle] = useState("");
  const [partnerCaption, setPartnerCaption] = useState("");
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [partnerLogoFile, setPartnerLogoFile] = useState<File | null>(null);
  const [sportBannerFile, setSportBannerFile] = useState<File | null>(null);
  const [termsConditions, setTermsConditions] = useState("");
  const [settings, setSettings] = useState<SiteSetting | null>(null);

  const token = localStorage.getItem("token");

  // Fetch settings on mount
  useEffect(() => {
    axios
      .get("https://api.jeetoo.bet/site_setting", {
        headers: { Authorization: `${token}` },
      })
      .then((res) => {
        setSettings(res.data);
        setTitle(res.data.title || "");
        setPartnerCaption(res.data.partner_caption || "");
        setTermsConditions(res.data.terms_conditions || "");
      })
      .catch((err) => {
        console.error("Failed to fetch site settings:", err);
      });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", title);
    formData.append("partner_caption", partnerCaption);
    if (logoFile) formData.append("logo", logoFile);
    if (partnerLogoFile) formData.append("partner_logo", partnerLogoFile);
    if (sportBannerFile) formData.append("sport_banner", sportBannerFile);
    formData.append("terms_conditions", termsConditions);

    try {
      await axios.post("https://api.jeetoo.bet/site_setting", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `${token}`,
        },
      });
      alert("Site settings updated successfully!");
      // Reload settings
      const res = await axios.get("https://api.jeetoo.bet/site_setting", {
        headers: { Authorization: `${token}` },
      });
      setSettings(res.data);
    } catch (error) {
      console.error("Error submitting site settings:", error);
      alert("Failed to update site settings.");
    }
  };

  return (
    <div className="ml-0  p-4">
      <h2 className="text-2xl font-semibold mb-6 text-gray-800">
        Site Settings
      </h2>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="text-gray-800 block mb-1 font-semibold">Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="border rounded p-2 w-full text-black"
          />
        </div>

        <div>
          <label className="text-gray-800 block mb-1 font-semibold">Upload Logo</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setLogoFile(e.target.files?.[0] || null)}
            className="border rounded p-2 w-full text-black"
          />
        </div>
        {settings?.logo && (
          <img
            src={
              settings.logo.startsWith("/")
                ? settings.logo
                : `https://api.jeetoo.bet/uploads/${settings.logo}`
            }
            alt="Logo"
            className="mt-2 w-32 h-32 object-contain"
          />
        )}

        <div>
          <label className="text-gray-800 block mb-1 font-semibold">Partner Section Caption</label>
          <input
            type="text"
            value={partnerCaption}
            onChange={(e) => setPartnerCaption(e.target.value)}
            className="border rounded p-2 w-full text-black"
            placeholder="e.g. Front Of Shirt Partner"
          />
        </div>

        <div>
          <label className="text-gray-800 block mb-1 font-semibold">Upload Partner Logo</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setPartnerLogoFile(e.target.files?.[0] || null)}
            className="border rounded p-2 w-full text-black"
          />
        </div>
        {settings?.partner_logo && (
          <img
            src={
              settings.partner_logo.startsWith("/")
                ? settings.partner_logo
                : `https://api.jeetoo.bet/uploads/${settings.partner_logo}`
            }
            alt="Partner Logo"
            className="mt-2 w-32 h-32 object-contain"
          />
        )}

        <div>
          <label className="text-gray-800 block mb-1 font-semibold">Upload Sports Banner</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setSportBannerFile(e.target.files?.[0] || null)}
            className="border rounded p-2 w-full text-black"
          />
        </div>
        {settings?.sport_banner && (
          <img
            src={
              settings.sport_banner.startsWith("/")
                ? settings.sport_banner
                : `https://api.jeetoo.bet/uploads/${settings.sport_banner}`
            }
            alt="Sports Banner"
            className="mt-2 w-full max-w-md h-auto object-contain rounded"
          />
        )}

        <div>
          <label className="text-gray-800 block mb-1 font-semibold">Terms & Conditions</label>
          <textarea
            value={termsConditions}
            onChange={(e) => setTermsConditions(e.target.value)}
            className="border rounded p-2 w-full text-black h-48 font-mono"
            placeholder="Write terms and conditions in HTML or plain text here..."
          />
        </div>



        <button
          type="submit"
          className="bg-blue-600 text-gray-800 py-2 px-4 rounded hover:bg-blue-700 font-semibold"
        >
          Save Settings
        </button>
      </form>
    </div>
  );
};

export default SiteSettings;
